import { useState, useEffect, useContext } from 'react'
import {ListContext} from "../../context/list/list.context";
import {OrganizationApi} from "../../api";
import {AuthContext} from "../../context/auth/auth.context";

export const useOrganizationList = (isPreloaded: boolean = true) => {
    const { organizationListContext, setOrganizationListContext } = useContext(ListContext);
    const { organizationIds } = useContext(AuthContext);
    // Info
    const [selectedOrganizationInfo, setSelectedOrganizationInfo] = useState<any>({});
    const [loadingOrganizationInfo, setLoadingOrganizationInfo] = useState(false);
    // List
    const [organizationList, setOrganizationList] = useState<any>([]);
    const [activeOrganizationList, setActiveOrganizationList] = useState<any>([]);
    const [userOrganizationList, setUserOrganizationList] = useState<any>([]);
    const [loadingOrganizationList, setLoadingOrganizationList] = useState<boolean>(false);

    useEffect(() => {
        if (isPreloaded && organizationListContext.length) {
            setOrganizationList(organizationListContext);
            loadActiveOrganizationList(organizationListContext);
        }
        else {
            loadOrganizationList();
        }
    }, []);

    const loadOrganizationList = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoadingOrganizationList(true);
            const payload = {
                '$select': 'id,name_en,name_bn,institute_type,description_en,description_bn,status,component_ids,short_name,logo_image,banner_image',
                '$orderby': 'sort_order asc,name_en asc',
            }
            OrganizationApi.dropdown(payload)
                .then(res => {
                    prepareListData(res.data.data.results);
                    resolve(res.data.data);
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => {
                    setLoadingOrganizationList(false);
                });
        });
    }

    const prepareListData = (list: any) => {
        setOrganizationList(list);
        loadActiveOrganizationList(list);
        if (isPreloaded) {
            setOrganizationListContext(list);
        }
        if (organizationIds) {
            loadUserOrganizationList(list);
        }
    }

    const loadActiveOrganizationList = (list: any) => {
        const activeList = list.filter(item => item.status === 1)
        setActiveOrganizationList(activeList);
    }

    const loadUserOrganizationList = (list: any) => {
        const orgList = list.filter(item => organizationIds.includes(item.id))
        setUserOrganizationList(orgList);
    }

    const getOrganizationById = (id) => {
        if(!organizationList) {
            return;
        }
        return organizationList.find(item => item.id === Number(id))
    }

    const loadOrganizationById = (id): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoadingOrganizationInfo(true);
            OrganizationApi.getById(id)
                .then(res => {
                    setSelectedOrganizationInfo(res.data.data);
                    setLoadingOrganizationInfo(false);
                    resolve(res.data.data);
                })
                .catch(err => {
                    setSelectedOrganizationInfo({});
                    setLoadingOrganizationInfo(false);
                    reject(err);
                });
        });
    }

    const setOrganizationFormFieldValue = (formRef, key, value) => {
        if (organizationList?.find((item) => item.id === Number(value))) {
            formRef.setFieldsValue({ [key]: value });
        } else {
            formRef.setFieldsValue({ [key]: null });
        }
    };

    return { loadingOrganizationInfo, loadingOrganizationList, loadOrganizationList, selectedOrganizationInfo, organizationList, activeOrganizationList, setOrganizationFormFieldValue, userOrganizationList, loadOrganizationById, getOrganizationById }
}
